import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class QbMappingService {

    private baseURL: string;

    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    getAvailableAccounts(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/QBMapping/GetAvailableAccounts`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    getQBOAccounts(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/QBMapping/GetQBOAccounts`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    getMappedAccounts(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/QBMapping/GetMappedAccounts`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    saveQBMapping(model: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/QBMapping/SaveQBMapping`,
            model,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    deleteQBMapping(id: number): Observable<any> {
        return this.http.delete<any>(
            `${this.baseURL}/QBMapping/DeleteQBMapping/${id}`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    getDefaultCustomer(): Observable<string> {
        return this.http.get(
            `${this.baseURL}/QBMapping/GetDefaultCustomer`,
            { responseType: 'text' }
        ).pipe(
            catchError(this.handleError)
        );
    }

    saveQBAccounts(model: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/QBMapping/SaveQBAccounts`,
            model,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    generateQBE(payload: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/QBMapping/GenerateQBE`,
            payload,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    getQBOSettings(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/QBMapping/GetQBOSettings`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    saveQBOSettings(model: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/QBMapping/SaveQBOSettings`,
            model,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    validateQBOConnection(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/QBMapping/ValidateQBOConnection`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    connectToQuickBooks(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/QBMapping/ConnectToQuickBooks`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    getPosSettings(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/POSSettings/GetPosSettings`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    exportToQBO(payload: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/QBMapping/ExportToQBO`,
            payload,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            return throwError(() => error.error.message);
        }
        return throwError(() => error.message || 'Server error');
    }
}